import { Injectable } from '@angular/core';
import { map, Observable, of, shareReplay } from 'rxjs';
import { TipoRisorsa } from '../_models/generated/tipo-risorsa';
import { StatoEnum } from '../_models/generated/stato-enum';

export interface EnumMetadata {
  value: number;
  name: string;
  label: string;
}

export interface EnumUiConfig {
  label?: string;
  color?: string; // alias per bg, usato spesso in Ionic/Tailwind
  bg?: string;
  icon?: string;
  [key: string]: any;
}

export type EnumUiMap = Record<number, EnumUiConfig>;

export interface EnumOption extends EnumMetadata {
  ui?: EnumUiConfig;
}

function buildEnumMetadata<T extends Record<string, number | string>>(enumObj: T): EnumMetadata[] {
  return Object.keys(enumObj)
    .filter(key => typeof enumObj[key] === 'number')
    .map(key => ({
      value: enumObj[key] as number,
      name: key,
      label: key
    }));
}

const LOCAL_ENUMS: Record<string, EnumMetadata[]> = {
  TipoRisorsa: buildEnumMetadata(TipoRisorsa),
  StatoEnum: buildEnumMetadata(StatoEnum)
};

@Injectable({ providedIn: 'root' })
export class MetaService {
  private enums$: Observable<Record<string, EnumMetadata[]>>;

  constructor() {
    // Usiamo enum locali per evitare dipendenze dal backend.
    this.enums$ = of(LOCAL_ENUMS).pipe(shareReplay(1));
  }

  getEnums(): Observable<Record<string, EnumMetadata[]>> {
    return this.enums$;
  }

  getEnumOptions(enumName: string, uiMap?: EnumUiMap): Observable<EnumOption[]> {
    return this.getEnums().pipe(
      map(enums => {
        const metadata = enums?.[enumName] || [];
        return metadata.map(m => {
          const ui = uiMap?.[m.value];
          return {
            ...m,
            label: ui?.label || m.label,
            ui: ui
          };
        });
      })
    );
  }
}
